import React from 'react';

const DvxButton = ({size = 24}) => {
  const adjustedSize = size - 4.5;
  return (
    <svg 
      width={adjustedSize} 
      height={adjustedSize}
      viewBox="0 0 255 255"
      style={{ 
        marginTop: '1px',
        color: 'var(--text-primary)' 
      }}
    >
      <g 
        transform="matrix(1.0007 0 0 1.0007 29.679 11.089)" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="18.394"
      >
        <path d="m48.949 28.893 46.423-27.643 97.011 55.528v117.99l-45.878-27.225v-58.647z"/>
        <path d="m146.56 203.78-46.423 27.643-97.011-55.528v-117.99l45.878 27.225v58.647z"/>
      </g>
    </svg>
  );
}

export default DvxButton
